import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-production-list',
  templateUrl: './production-list.component.html',
  styleUrls: ['./production-list.component.css']
})
export class ProductionListComponent implements OnInit {

  public menu_item_id = '52';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  itemCats = [];
  all_itemSubCats = [];
  itemSubCats = [];
  branchList = [];
  allStoreList = [];
  storeList = [];

  displayedColumns = ['sub_item_no', 'main_item_name', 'production_date', 'quantity', 'unit_name', 'available_count',
    'edit', 'del'];
  displayedColumns2 = ['sub_item_no', 'main_item_name', 'production_date', 'quantity', 'unit_name', 'available_count'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'production', 'from_date': new Date(), 'to_date': new Date(), 'main_item_name': '',
    'sub_item_no': '', 'item_cat_id': '', 'item_subcat_id': '', 'branch_id': '0', 'store_id': '0',
    'title': 'قائمة الإنتاج'
  };
  from_date = '';
  to_date = '';

  Success_Msg; Error_Msg; Del_Msg; Sub_Cat_Msg; Production_List;
  From_Date; To_Date; Main_Item_Name; Sub_Item_Number;
  Main_Cat; Sub_Cat; Branch_Msg; Store_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sub_Cat_Msg').subscribe((res: string) => {
      this.Sub_Cat_Msg = res;
    });

    translate.get('Main_Item_Name').subscribe((res: string) => {
      this.Main_Item_Name = res;
    });

    translate.get('Production_List').subscribe((res: string) => {
      this.Production_List = res;
    });
    this.model['title'] = this.Production_List;

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Sub_Item_Number').subscribe((res: string) => {
      this.Sub_Item_Number = res;
    });

    translate.get('Sub_Cat').subscribe((res: string) => {
      this.Sub_Cat = res;
    });

    translate.get('Main_Cat').subscribe((res: string) => {
      this.Main_Cat = res;
    });


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Branch_Msg').subscribe((res: string) => {
      this.Branch_Msg = res;
    });

    translate.get('Store_Msg').subscribe((res: string) => {
      this.Store_Msg = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = this.queryList.all_itemCat;
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.itemCats = data.data['list'];
      });

    query = this.queryList.all_itemSubCat;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.all_itemSubCats = data.data['list'];
      });

    query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'اختر', 'branch_name_en': 'Select' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });

  }

  getSubCat() {
    this.itemSubCats = [];
    this.all_itemSubCats.forEach(element => {
      if (element.item_cat_id == this.model['item_cat_id'])
        this.itemSubCats.push(element);
    });
    this.model['item_subcat_id'] = this.itemSubCats[0]['item_subcat_id'];
  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'اختر', 'store_name_en': 'Select' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + this.from_date + '</td>';
    html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td>';
    html_data += '<td width="33%"> ' + this.Main_Item_Name + ': ' + this.model['main_item_name'] + ' </td></tr>';
    html_data += '<tr><td width="33%"> ' + this.Sub_Item_Number + ': ' + this.model['sub_item_no'] + '</td>';
    html_data += '<td width="33%"> ' + this.Main_Cat + ': ';
    if (this.model['item_cat_id'] != '') {
      this.itemCats.forEach(element => {
        if (element.item_cat_id == this.model['item_cat_id'])
          html_data += element.item_cat_name;
      });
    }
    html_data += '</td>';
    html_data += '<td width="33%"> ' + this.Sub_Cat + ': ';
    if (this.model['item_subcat_id'] != '') {
      this.itemSubCats.forEach(element => {
        if (element.item_subcat_id == this.model['item_subcat_id'])
          html_data += element.item_subcat_name;
      });
    }
    html_data += ' </td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('production_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }



  search() {

    if (this.model['branch_id'] == '0') {
      alert(this.Branch_Msg);
      return false;
    }

    if (this.model['store_id'] == '0') {
      alert(this.Store_Msg);
      return false;
    }

    let condition = "";

    if (this.model['from_date'] != undefined) {
      this.from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + " 00:00:00";
      condition += " AND `production`.`production_date` >= '" + this.from_date + "'";
    }

    if (this.model['to_date'] != undefined) {
      this.to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + " 23:59:59";
      condition += " AND `production`.`production_date` <= '" + this.to_date + "'";
    }

    //condition += " AND `production`.`production_date` BETWEEN '" + from_date + "' AND '" + to_date + "'";

    if (this.model['main_item_name'] != '')
      condition += " AND (`main_item`.`main_item_name` LIKE '%" + this.model['main_item_name'] +
        "%' OR `main_item`.`main_item_name_en` LIKE '%" + this.model['main_item_name'] + "%')";

    if (this.model['sub_item_no'] != '')
      condition += " AND `sub_item`.`sub_item_no` LIKE '%" + this.model['sub_item_no'] + "%'";

    if (this.model['item_cat_id'] != '') {
      if (this.model['item_subcat_id'] != '')
        condition += " AND `main_item`.`item_subcat_id` = '" + this.model['item_subcat_id'] + "'";
      else
        alert(this.Sub_Cat_Msg);
    }

    if (this.model['store_id'] != '0')
      condition += " AND `production`.`store_id` = '" + this.model['store_id'] + "'";

    if (this.model['item_cat_id'] == '' || (this.model['item_cat_id'] != '' && this.model['item_subcat_id'] != '')) {

      let query = "SELECT `production`.*, `unit`.`unit_name`, `main_item`.`main_item_name`, " +
        "'' AS 'available_count', `sub_item`.`sub_item_no` FROM `production`, `unit`, `main_item`, `sub_item` WHERE " +
        "`production`.`status` = '1' AND `production`.`sub_item_number` = `sub_item`.`sub_item_number` AND " +
        "`sub_item`.`main_item_id` = `main_item`.`main_item_id` AND `production`.`unit_id` = `unit`.`unit_id`" +
        condition + " AND `production`.`store_id` IN (SELECT `store`.`store_id` FROM `store`, `branch_auth` WHERE" +
        " `branch_auth`.`branch_id` = `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1'" +
        " AND `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
        "' AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "')";
      // console.log(query);

      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.data['list'];

          this.dp.forEach(element => {
            let obj2 = {
              cmd: 'getAvailableStock', store_id: '1', sub_item_no: element.sub_item_no,
              stock_no: element.stock_no
            };
            // console.log(obj2);
            this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj2)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();

                element.available_count = data.status['msg'][0]['available_count'];
                // console.log(data.status['msg']);
                this.dataSource = new MatTableDataSource(this.dp);
                this.dataSource.sort = this.sort;

              });
          });
        });
    }
  }

  delProd(production_no) {

    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'production_no': production_no }];
      values.push({ 'table_name': 'production_content', 'production_no': production_no });
      values.push({ 'table_name': 'stock', 'production_no': production_no });
      values.push({ 'table_name': 'stock_base', 'production_no': production_no });

      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
